class RegistrationConfirmationEmailSettings {
    constructor(data) {
        this.enabled = typeof data.enabled === 'boolean' ? data.enabled : true;
        this.subject = data.subject || '';
        this.bodyText = data.bodyText || '';
    }
}

export default RegistrationConfirmationEmailSettings;
